
(function (i, s, o, g, r, a, m) {
  i['GoogleAnalyticsObject'] = r; i[r] = i[r] || function () {
    (i[r].q = i[r].q || []).push(arguments)
  }, i[r].l = 1 * new Date(); a = s.createElement(o),
    m = s.getElementsByTagName(o)[0]; a.async = 1; a.src = g; m.parentNode.insertBefore(a, m)
})(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga');

ga('create', 'UA-123196088-1', 'auto')
ga('send', 'pageview')

import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store/index';
import './plugins/element';
import i18n from './i18n';
import VueClipboard from 'vue-clipboard2';
import VueCookie from 'vue-cookie';
import VeLine from 'v-charts/lib/line.common'
import VeHistogram from 'v-charts/lib/histogram.common.js'
import 'v-charts/lib/style.css'

// import ga from 'vue-ga'
// import VueAnalytics from 'vue-analytics'
// Vue.use(VueAnalytics, {
//   id: 'UA-123196088-1'
// })

Vue.config.productionTip = false;
// 复制非button组件设置
VueClipboard.config.autoSetContainer = true;// add this line
// 设置页面title
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

// import {
//   MessageBox,
//   Message,
// } from 'element-ui';
// Vue.prototype.$msgbox = MessageBox;
// Vue.prototype.$message = Message;

router.afterEach(function (to) {
  if (window.ga) {
    let path = to.fullPath;
    (path === '/') && (path = '/console');
    window.ga('set', 'page', path) // 你可能想根据请求参数添加其他参数，可以修改这里的 to.fullPath
    window.ga('send', 'pageview')
  }
})

import 'swiper/dist/css/swiper.min.css'
import 'swiper/dist/js/swiper.min'

Vue.use(VueClipboard);
Vue.use(VueCookie);
Vue.component(VeLine.name, VeLine);
Vue.component(VeHistogram.name, VeHistogram);

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app');



$(() => {
  $(".regular").slick({
    dots: true,
    dotsClass: 'advantage-dots slick-dots',
    infinite: true, //无限循环
    arrows: false,  //启用下一个/上一个箭头
    slidesToShow: 1,    //一次显示的幻灯片数量
    slidesToScroll: 1, //一次滚动的幻灯片数量
    autoplay: false, //自动播放
    autoplaySpeed: 5000  //自动播放速度
  });

  let currentSlide = 0;
  let currentIcon = 0;

  $('.pc-icon-wrapper .pc-icon').on('click', function () {
    let activeDomNormalSrc = $('.pc-icon.active img').attr('normal-src');
    $('.pc-icon.active').removeClass('active').find('img').attr('src', activeDomNormalSrc);

    let hoverSrc = $(this).find('img').attr('active-src');
    $(this).addClass('active').find('img').attr('src', hoverSrc);

    currentIcon = $(this).attr('index');
    if (currentSlide !== currentIcon) {
      $(`#slick-slide-control0${currentIcon}`).click();
    }
  });

  $($('.pc-icon-wrapper .pc-icon')[0]).click();

  if ($('.pc-icon-wrapper').width() > 0) {
    $('.regular').slick('slickSetOption', 'autoplay', false, true);
  }

  $(".regular").on('beforeChange', function (event, slick, currentSlide, nextSlide) {
    currentSlide = nextSlide;
    if (currentIcon !== currentSlide) {
      $($('.pc-icon-wrapper .pc-icon')[currentSlide]).click();
    }
  });

  window.scrollTo(0, 0);//移动到顶部


  // 菜单交互逻辑，前项目直接移动
  $('.mobile-nav-icon').on('click', function (e) {
    $('.nav-list').slideToggle(300);
  })
  $('.nav-item').on('click', function (e) {
    let $navItem = $(this);

    if ($('.mobile-nav-icon').width() > 0) {
      $('.nav-list').slideToggle(300);
    } else {
      $('.nav-item').removeClass('active');
      $navItem.addClass('active');
    }
  })

  let time = 200;
  let timeClock = null;

  let anchors = [];
  for (let i = 0; i < ('.nav-item').length; i++) {
    anchors.push($($('.nav-item')[i]).attr('anchor'));
  }
  let getCurrentAnchors = () => {
    let scrollTop = $(window).scrollTop();
    let i = 0;
    while (anchors[i]) {
      if ($(`#${anchors[i]}`).offset().top > scrollTop + 60) {
        break;
      }
      i++;
    }
    i = (i > 0) ? i - 1 : 0;
    return anchors[i];
  }

  $(window).on('load scroll', function () {
    if ($('.mobile-nav-icon').width() > 0 || timeClock) {
      return;
    }
    timeClock = setTimeout(() => {
      clearTimeout(timeClock);
      timeClock = null;
      var shouldCheckedNav = getCurrentAnchors();
      $(`.nav-item[anchor='${shouldCheckedNav}']`).click();
    }, time)
  })



  // 
  
});

